document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-cb-ld-craft]');

  sections.forEach(function (section) {
    var videos = Array.prototype.slice.call(
      section.querySelectorAll('.cb-ld-craft-card__video')
    );

    if (!videos.length) return;

    videos.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
    });

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        video.play().catch(function () {});
      });

      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      {
        root: null,
        threshold: 0.35
      }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  });
});

document.addEventListener('shopify:section:load', function (event) {
  var section = event.target.querySelector('[data-cb-ld-craft]');

  if (!section) return;

  var videos = Array.prototype.slice.call(
    section.querySelectorAll('.cb-ld-craft-card__video')
  );

  videos.forEach(function (video) {
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.play().catch(function () {});
  });
});